import React from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import { Task } from '../../../types';
import { TaskFormWrapper } from './TaskFormWrapper';

interface InterrogatoriesFormProps {
  task: Task;
  onSubmit: (formData: any) => void;
}

export const InterrogatoriesForm: React.FC<InterrogatoriesFormProps> = ({
  task,
  onSubmit
}) => {
  const [formData, setFormData] = React.useState({
    interrogatoryType: '',
    partyName: '',
    questions: '',
    legalBasis: '',
    objections: '',
    additionalNotes: '',
  });

  const handleChange = (field: string, value: any) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <TaskFormWrapper task={task} onSubmit={() => onSubmit(formData)}>
      <FormControl fullWidth>
        <InputLabel>Interrogatory Type</InputLabel>
        <Select
          value={formData.interrogatoryType}
          label="Interrogatory Type"
          onChange={(e) => handleChange('interrogatoryType', e.target.value)}
        >
          <MenuItem value="general">General</MenuItem>
          <MenuItem value="expert">Expert</MenuItem>
          <MenuItem value="contention">Contention</MenuItem>
          <MenuItem value="identification">Identification</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Party Name"
        fullWidth
        value={formData.partyName}
        onChange={(e) => handleChange('partyName', e.target.value)}
      />

      <TextField
        label="Questions"
        fullWidth
        multiline
        rows={6}
        value={formData.questions}
        onChange={(e) => handleChange('questions', e.target.value)}
        placeholder="Enter each question on a new line"
      />

      <TextField
        label="Legal Basis"
        fullWidth
        multiline
        rows={3}
        value={formData.legalBasis}
        onChange={(e) => handleChange('legalBasis', e.target.value)}
      />

      <TextField
        label="Anticipated Objections"
        fullWidth
        multiline
        rows={2}
        value={formData.objections}
        onChange={(e) => handleChange('objections', e.target.value)}
      />

      <TextField
        label="Additional Notes"
        fullWidth
        multiline
        rows={2}
        value={formData.additionalNotes}
        onChange={(e) => handleChange('additionalNotes', e.target.value)}
      />
    </TaskFormWrapper>
  );
};